import * as request from "../utils/request"
import * as ua from "../utils/ua"
import localStorage from "../utils/localStorage"
import * as helper from "../utils/helper"
import * as urlUtil from "../utils/url"
import { union, intersection } from "lodash"
import couponStatus from "@constants/couponState.js"

const PRICE_TYPE = {
  GAME_COIN: "GAMECOIN",
  RMB: "RMB"
}

/**
 * 获取游戏大区js
 * @param {*} gameCode 游戏AMSID
 */
export function getGameServerJs(amsGameCode) {
  return new Promise(resolve => {
    if (window[amsGameCode.toUpperCase() + "ServerSelect"]) {
      resolve(window[amsGameCode.toUpperCase() + "ServerSelect"])
    } else {
      request
        .getScript(`//pvp.qq.com/comm-htdocs/js/game_area/utf8verson/${amsGameCode}_server_select_utf8.js?r="${Math.random()}`)
        .then(() => {
          resolve(window[amsGameCode.toUpperCase() + "ServerSelect"])
        })
        .catch(e => {
          throw e
        })
    }
  })
}

/**
 * 获取游戏area和platid
 * @param {*} amsGameCode 游戏AMSID
 */
export function getServerPtConfig(amsGameCode) {
  let userAgent = ua.getUserAgent()
  let platid = null
  let area = null

  if (!amsGameCode) {
    return null
  }
  return getGameServerJs(amsGameCode).then(() => {
    var sk = null
    if (userAgent.android) {
      platid = 1
      sk = "android"
    } else if (userAgent.iOS) {
      platid = 0
      sk = "ios"
    }
    var k = null
    if (userAgent.QQ) {
      k = "qq"
    } else if (userAgent.weixin) {
      k = "weixin"
    }
    if (
      sk &&
      k &&
      window[amsGameCode.toUpperCase() + "ServerSelect"] &&
      window[amsGameCode.toUpperCase() + "ServerSelect"].STD_CHANNEL_DATA
    ) {
      var i = 0
      for (i; i < window[amsGameCode.toUpperCase() + "ServerSelect"].STD_CHANNEL_DATA.length; i++) {
        var cur = window[amsGameCode.toUpperCase() + "ServerSelect"].STD_CHANNEL_DATA[i]
        if (cur.sk == sk && cur.k == k) {
          area = cur.v
          break
        }
      }
    }

    return {
      area,
      platid
    }
  })
}

/**
 * 判断道具是否下线
 * @param {*} goods
 */
export function isOffline(goods) {
  if (goods && goods.OnlineTime && goods.OfflineTime) {
    let now = window._serverTime ? new Date(window._serverTime) : new Date()
    if (!isValidDate(now)) now = new Date()
    var sTime = now.getTime()
    if (new Date(goods.OnlineTime).getTime() > sTime || new Date(goods.OfflineTime).getTime() < sTime) {
      return true
    }
    return false
  } else {
    return true
  }
}

/**
 * 判断当前时间是否在道具上线保护期
 * @param {*} goods
 */
export function isInProtectTime(goods) {
  if (goods && goods.ProtectTime) {
    let now = window._serverTime ? new Date(window._serverTime) : new Date()
    if (!isValidDate(now)) now = new Date()
    return helper.UTC8TimeToTimeStamp(goods.ProtectTime) > now.getTime()
  } else {
    return false
  }
}

/**
 * 处理道具价格数据
 * @param {*} props
 * @param {*} rate 汇率 1元=N游戏币
 * @param {*} unit 单位
 * @param {*} showPriceType 商品展示的价格类型 (游戏币价格或者现金价格，默认游戏币价格)
 * @param {*} payChannel 业务层级道具支付渠道屏蔽情况
 * @param {*} pfSource 来源pf
 * @return
 * salePrice 点券售卖价
 * saleCashPrice 现金售卖价（分）
 * saleCashRMBPrice 现金售卖价（元）
 * totalPrice 有活动时点券原价
 * totalCashPrice 有活动时现金原价（分）
 * totalCashRMBPrice 有活动时现金原价（元）
 * showGameCoinPrice 该道具是否展示游戏币价格
 * dc 业务层级和道具层级联合控制道具的支付渠道屏蔽
 * channelInfo 新增业务支付渠道，需要把道具价格和单位替换为新业务支付渠道
 * offerId 指定平台，根据平台来读取活动号。【游戏内索要使用】
 */
export function handlePropsPrice({
  props,
  rate = 10,
  unit,
  showPriceType = "GAMECOIN",
  payChannel = [],
  pfSource = "",
  channelInfo = {},
  isLOL = false,
  offerId = ""
}) {
  if (!rate) rate = 10
  let defaultActivity = null
  let sourceActivity = null
  let platformActivity = null
  let disableActivity = false
  if (props) {
    props.saleCashPrice = props.goodsSalesPrice ? new Number(props.goodsSalesPrice).toFixed(0) : ""
    props.totalCashPrice = props.goodsTotalPrice ? new Number(props.goodsTotalPrice).toFixed(0) : ""
    props.saleCashRMBPrice = props.saleCashPrice ? (props.saleCashPrice / 100).toFixed(2) : ""
    props.totalCashRMBPrice = props.totalCashPrice ? (props.totalCashPrice / 100).toFixed(2) : ""

    props.salePrice = props.saleCashPrice ? ((new Number(props.saleCashPrice) / 100) * rate).toFixed(0) : ""
    props.totalPrice = props.totalCashPrice ? ((new Number(props.totalCashPrice) / 100) * rate).toFixed(0) : ""

    // 处理渠道活动号 || 如果没有配置渠道活动或渠道活动失效，默认使用商店活动
    if (props?.goodsExtend?.SourceActivity) {
      try {
        props.goodsExtend.SourceActivity.split(";").forEach(activity => {
          let activityConfig = urlUtil.getParams(activity, true)

          let { pfsource: activityPfsource, num, price, start, end, disable } = activityConfig || {}
          // 分渠道禁用活动disableActivity，当配置了商店活动，又希望某个渠道不能参与活动
          if (activityPfsource == pfSource && disable) {
            disableActivity = true
          }
          if (activityPfsource == pfSource && num && price && start && end && checkTimeValid(start, end) && !disable) {
            sourceActivity = activityConfig
          }
          if (activityPfsource == "default" && num && price && start && end && checkTimeValid(start, end) && !disable) {
            defaultActivity = activityConfig
          }

          if (offerId && activityPfsource == offerId && num && price && start && end && checkTimeValid(start, end) && !disable) {
            platformActivity = activityConfig
          }
        })
      } catch (error) {
        console.log(error)
      }

      let activity = platformActivity ? platformActivity : sourceActivity ? sourceActivity : defaultActivity ? defaultActivity : null
      if (activity) {
        props.goodsExtend.ActivityNum = activity.num
        props.goodsExtend.ActivityPrice = activity.price
        props.goodsExtend.ActivityBegin = activity.start
        props.goodsExtend.ActivityEnd = activity.end
      }
    }

    // 分渠道禁用活动disableActivity,则也不读取商店活动号
    if (disableActivity) {
      props.goodsExtend.ActivityNum = ""
      props.goodsExtend.ActivityPrice = ""
      props.goodsExtend.ActivityBegin = ""
      props.goodsExtend.ActivityEnd = ""
    }

    if (checkActivityValid(props, isLOL) && !disableActivity) {
      props.saleCashPrice = props.goodsExtend.ActivityPrice ? new Number(props.goodsExtend.ActivityPrice).toFixed(0) : ""
      props.saleCashRMBPrice = props.saleCashPrice ? (props.saleCashPrice / 100).toFixed(2) : ""
      props.salePrice = props.saleCashPrice ? ((new Number(props.saleCashPrice) / 100) * rate).toFixed(0) : ""
    }
    if (props.salePrice === props.totalPrice) {
      props.totalPrice = ""
      props.totalCashPrice = ""
      props.totalCashRMBPrice = ""
    }
    if (showPriceType == PRICE_TYPE.GAME_COIN) {
      props.showGameCoinPrice = true
    }

    // 处理道具的支付渠道屏蔽逻辑
    let disableDc = props && props.goodsExtend && props.goodsExtend.DisableDc == 1,
      props_dc = (props && props.goodsExtend && props.goodsExtend.DisableChannel) || "",
      business_dc = handleGameBizPayDC({ pfSource, payChannel })

    // DisableDc为true时（即屏蔽除道具层级屏蔽规则），dc只保留道具层级屏蔽规则；否则合并道具层级和业务层级屏蔽规则
    if (disableDc) {
      props.dc = props_dc
    } else {
      props.dc = `${business_dc}${business_dc && props_dc ? "," : ""}${props_dc}`
    }

    // 如果道具屏蔽了点券，则显示现金价
    if (props.dc.indexOf("game_coin") > -1) {
      props.showGameCoinPrice = false
    }

    // 新支付渠道价格
    if (channelInfo?.rate && channelInfo?.unit) {
      props.showGameCoinPrice = false
      props.saleChannelPrice = props.saleCashPrice ? ((new Number(props.saleCashPrice) / 100) * channelInfo.rate).toFixed(0) : ""
      props.totalChannelPrice = props.totalCashPrice ? ((new Number(props.totalCashPrice) / 100) * channelInfo.rate).toFixed(0) : ""
    }

    props.rate = channelInfo?.rate || rate
    props.unit = channelInfo?.unit || unit

    // 金币价部分
    if (checkInGameCoinActivityValid(props)) {
      props.saleInGameCoinPrice = props?.goodsExtend?.InGameCoinActivityPrice
        ? new Number(props.goodsExtend.InGameCoinActivityPrice).toFixed(0)
        : ""
      props.totalInGameCoinPrice = props?.goodsExtend?.InGameCoinPrice ? new Number(props.goodsExtend.InGameCoinPrice).toFixed(0) : ""
    } else {
      props.saleInGameCoinPrice = props?.goodsExtend?.InGameCoinPrice ? new Number(props.goodsExtend.InGameCoinPrice).toFixed(0) : ""
      props.totalInGameCoinPrice = ""
    }
  }

  return props
}

export const calTimeCountDown = goods => {
  let endTime = new Date(goods?.countdownTime.replace(/-/g, "/")).getTime()
  let timediff = endTime - new Date().getTime()

  if (timediff > 0) {
    let days = Math.floor(timediff / (1000 * 60 * 60) / 24)
    return `剩余时间: ${days > 0 ? `<span>${days}天</span>` : "今天结束"}`
  } else {
    return ""
  }
}

/**
 * 处理道具描述标签数据
 * TODO 由于LOL没有切专区。导致LOL需要特殊逻辑取icon
 * @param {*} props
 */
export function handlePropsContent({ props, isLOL = false, vmallConfigByAMSID }) {
  if (props) {
    props.remark = (props.goodsExtend && props.goodsExtend.RecommReason) || props.goodsRemark || ""
    //物品是否只能买一个
    props.singleton = props.itemExtend?.Singleton === "1"

    // 运营标签需要在活动时间内才可显示
    props.activityTag = (props.goodsExtend && checkActivityTimeValid(props) && props.goodsExtend.OperationTag) || ""
    props.activityTags = (props.activityTag && props.activityTag.split(/,|;|\s/)) || []
    props.activityTag = (props.activityTag.split(/,|;|\s/) && props.activityTag.split(/,|;|\s/)[0]) || ""

    props.tagClass = ""
    if (props.activityTag) {
      if (props.activityTag.indexOf("上新") > -1) {
        props.tagClass = "simple-module-item-tag--new"
      } else if (props.activityTag.indexOf("返场") > -1) {
        props.tagClass = "simple-module-item-tag--return"
      } else if (props.activityTag.indexOf("折扣") > -1) {
        props.tagClass = "simple-module-item-tag--discount"
      }
    }
    // 属性标签
    props.tag = (props.goodsExtend && props.goodsExtend.Tag) || ""
    props.tags = props.tag ? props.tag.split(/,|;|\s/) : []
    props.tag = (props.tag.split(/,|;|\s/) && props.tag.split(/,|;|\s/)[0]) || ""

    // 道具纯图片货架
    if (props.goodsExtend && props.goodsExtend.PictureShelf) {
      props.pictureShelf = []
      props.goodsExtend.PictureShelf.split(";").forEach(shelf => {
        if (shelf.indexOf("=") > -1) {
          // 用 & 和 = 的是新协议
          let pictureShelfConfig = urlUtil.getParams(shelf, true)
          if (pictureShelfConfig && pictureShelfConfig.pic) {
            props.pictureShelf.push({
              pfsource: pictureShelfConfig.pfsource || "",
              dispfsource: pictureShelfConfig.dispfsource || "",
              title: pictureShelfConfig.title || "",
              pic: pictureShelfConfig.pic.split(",") || [],
              link: pictureShelfConfig.link || "",
              vid: pictureShelfConfig.vid || ""
            })
          }
        } else {
          // 兼容老协议
          if (shelf.split(",")[0]) {
            props.pictureShelf.push({
              title: shelf.split(",")[0],
              pic: shelf.split(",").slice(1),
              link: ""
            })
          }
        }
      })
    }

    if (props.goodsExtend && props.goodsExtend.DetailVideo) {
      let videoConfig = urlUtil.getParams(props.goodsExtend.DetailVideo, true)
      props.detailVideo = {}
      if (videoConfig.vid) {
        props.detailVideo.vid = videoConfig.vid
        props.detailVideo.poster = videoConfig.poster
      }
      if (videoConfig.src) {
        props.detailVideo.src = videoConfig.src
        props.detailVideo.poster = videoConfig.poster
      }
    }

    // 读取道具大图
    // [0] 方形小图，给弹窗里使用
    // [1] 方形大图给详情页头部和小豆腐块使用
    // [2] banner横图给广告位使用
    if (props.allIcon && props.allIcon[1] && props.allIcon[1] !== "null") props.hdIcon = props.allIcon[1]
    if (props.allIcon && props.allIcon[2] && props.allIcon[2] !== "null") props.bannerIcon = props.allIcon[2]

    if (isLOL) {
      // LOL道具，icon为长形，需要替换成正方形
      // [0] banner横图
      // [1] 方形高清大图
      // [2] 方形小图
      // 由于Vmall存在历史数据，导致[2]不一定是方形小图片，这里统一使用[1]
      if (props.allIcon && props.allIcon[1] && props.allIcon[1] !== "null") props.icon = props.allIcon[1]
      if (props.allIcon && props.allIcon[0] && props.allIcon[0] !== "null") props.bannerIcon = props.allIcon[0]
      // if (props.allIcon && props.allIcon[2] && props.allIcon[2] !== "null") props.icon = props.allIcon[2]
    }

    // 倒计时展示，用于限时返场，限时折扣等场景
    if (props.goodsExtend && props.goodsExtend.CountdownTime) {
      props.countdownTime = props.goodsExtend.CountdownTime
      props.countDownText = calTimeCountDown(props)
    }

    // 处理道具的最大数量
    props.maxQuantity = getActivityMaxQuantity(props)

    // 处理道具奖励任务
    props.giftTask = getGiftTask(props)

    // 处理秒杀活动配置
    props.seckillActivity = getSeckillActivity(props)
    //处理60卡活动配置
    props.specificDiscountCard = getSpecificDiscountCard(props, vmallConfigByAMSID)
    //当前60卡可用皮肤的信息
    props.specific60CardCoupon = getSpecific60CardCoupon(props)
  }
  return props
}

/**
 * 处理道具团购活动
 * @param {*} props
 * @param {*} pfSource 来源pf
 * @return
 */
export function handlePropsGroupActivity({ props, pfSource = "" }) {
  let groupActivity = null
  let defaultGroupActivity = null
  let sourceGroupActivity = null
  let disableGroup = false

  if (props) {
    // 处理渠道活动号 || 如果没有配置渠道活动或渠道活动失效，默认使用商店活动
    if (props?.goodsExtend?.GroupActivity) {
      try {
        props.goodsExtend.GroupActivity.split(";").forEach(activity => {
          let activityConfig = urlUtil.getParams(activity, true)

          let { pfsource: activityPfsource, buyGroupId, fissionGroupId, teamGroupid, price, start, end, disable } = activityConfig || {}

          // 当配置了default，又希望某个渠道不能参与团购
          if (activityPfsource == pfSource && disable) {
            disableGroup = true
          }

          if (buyGroupId && (teamGroupid || fissionGroupId) && price && start && end && checkTimeValid(start, end)) {
            let config = {
              ...activityConfig
            }
            if (activityPfsource == "default") {
              defaultGroupActivity = config
            }

            if (activityPfsource == pfSource) {
              sourceGroupActivity = config
            }
          }
        })
      } catch (error) {
        console.log(error)
      }
    }

    groupActivity = sourceGroupActivity ? sourceGroupActivity : defaultGroupActivity ? defaultGroupActivity : null
    if (disableGroup) groupActivity = null

    if (groupActivity) {
      groupActivity.saleCashPrice = groupActivity.price ? new Number(groupActivity.price).toFixed(0) : ""
      groupActivity.saleCashRMBPrice = groupActivity.saleCashPrice ? (groupActivity.saleCashPrice / 100).toFixed(2) : ""
      groupActivity.salePrice = groupActivity.saleCashPrice ? ((new Number(groupActivity.saleCashPrice) / 100) * props.rate).toFixed(0) : ""

      //如果团购价和售卖价一致则不展示普通购买按钮
      if (props.salePrice === groupActivity?.salePrice) {
        groupActivity.disableNormalBuy = true
      }
    }
  }

  return groupActivity
}

/**
 * 校验限时活动(包括限时返场，折扣等)是否有效
 * @param {*} props
 */
export function checkActivityTimeValid(props) {
  let flag = false
  if (props && props.goodsExtend) {
    let { ActivityBegin, ActivityEnd } = (props && props.goodsExtend) || {}
    if (ActivityBegin && ActivityEnd) {
      flag = checkTimeValid(ActivityBegin, ActivityEnd)
    }
  }
  return flag
}

/**
 * 校验限时活动（限时折扣）是否有效
 * @param {*} props
 * @param {*} isLOL
 */
export function checkActivityValid(props, isLOL) {
  let flag = false
  let { ActivityBegin, ActivityEnd, ActivityPrice, ActivityNum } = (props && props.goodsExtend) || {}
  if ((ActivityNum && ActivityPrice && ActivityBegin && ActivityEnd) || (isLOL && ActivityPrice && ActivityBegin && ActivityEnd)) {
    // 检查drm活动号的有效时间
    flag = checkTimeValid(ActivityBegin, ActivityEnd)
  }
  return flag
}

/**
 * 校验金币限时活动（限时折扣）是否有效
 * @param {*} props
 */
export function checkInGameCoinActivityValid(props) {
  let flag = false
  let { InGameCoinActivityBegin, InGameCoinActivityEnd, InGameCoinActivityPrice } = (props && props.goodsExtend) || {}
  if (InGameCoinActivityBegin && InGameCoinActivityEnd && InGameCoinActivityPrice) {
    // 检查活动有效时间
    flag = checkTimeValid(InGameCoinActivityBegin, InGameCoinActivityEnd)
  }
  return flag
}

/**
 * 校验物品活动是否有效
 * @param {*} props
 * return flag
 */
export function checkActivityTimeStatus(props) {
  let flag = 0
  if (props && props.goodsExtend) {
    let { ActivityBegin, ActivityEnd } = (props && props.goodsExtend) || {}
    if (ActivityBegin && ActivityEnd) {
      flag = checkTimeStatus(ActivityBegin, ActivityEnd)
    }
  }
  return flag
}

/**
 * 校验时间是否有效
 * @param {*} props
 * return flag
 * 0 活动不存在
 * 1 活动有效
 * 2 活动未开始
 * 3 活动已结束
 */
export function checkTimeStatus(beginTime, endTime) {
  let flag = 0
  let now = window._serverTime ? new Date(window._serverTime) : new Date()
  if (!isValidDate(now)) now = new Date()
  let serverTimeNum = now.getTime()

  if (beginTime && serverTimeNum < helper.UTC8TimeToTimeStamp(beginTime)) {
    flag = 2
  } else if (endTime && serverTimeNum > helper.UTC8TimeToTimeStamp(endTime)) {
    flag = 3
  } else if (
    beginTime &&
    endTime &&
    serverTimeNum > helper.UTC8TimeToTimeStamp(beginTime) &&
    serverTimeNum < helper.UTC8TimeToTimeStamp(endTime)
  ) {
    flag = 1
  }

  return flag
}

export function overActivityTime(time) {
  let flag = false
  let now = window._serverTime ? new Date(window._serverTime) : new Date()
  if (!isValidDate(now)) now = new Date()
  if (time) {
    // new Data 的时候 需要将字符时间的 “-” 转成 “/”，否则在 ios 无法正确转换
    let serverTimeNum = now.getTime()
    if (serverTimeNum > helper.UTC8TimeToTimeStamp(time)) {
      flag = true
    }
  }
  return flag
}

/**
 * 判断道具是否是预上线状态
 * @param {*} prop
 */
export function isPreview(prop) {
  if (prop && prop.goodsExtend && prop.goodsExtend.PreviewEndTime) {
    if (overActivityTime(prop.goodsExtend.PreviewEndTime)) {
      return false
    } else {
      // 配置了预上线结束时间，且当前还在预上线时间内
      return true
    }
  }
  return false
}

/**
 * 判断道具是否是体验卡
 * @param {*} props
 */
export function isExperienceCard(props) {
  try {
    if (props.itemExtend && props.itemExtend.ItemType == "4" && props.itemExtend.LinkID) {
      return true
    }
    return false
  } catch (error) {
    return false
  }
}

/**
 * 判断道具是否是外链物品
 * @param {*} props
 */
export function isOutLinkGoods(props) {
  if (props.itemExtend && props.itemExtend.ItemType == "104" && props.itemExtend.Link) {
    return true
  } else {
    return false
  }
}

/**
 * 校验体验卡活动是否有效
 * @param {*} props
 */
export function checkCardActivityValid(props) {
  let flag = false
  let { CardBegin, CardEnd, CardActivityId } = (props && props.goodsExtend) || {}
  if (CardBegin && CardEnd && CardActivityId) {
    flag = checkTimeValid(CardBegin, CardEnd)
  }
  return flag
}

/**
 * 校验活动时间是否有效
 * @param beginTime
 * @param endTime
 * @param useLocalDate 使用本地时间
 */
export function checkTimeValid(beginTime, endTime, useLocalDate) {
  let flag = false
  // 优先使用服务器时间
  let now = window._serverTime ? new Date(window._serverTime) : new Date()
  if (!isValidDate(now)) now = new Date()

  // 指定使用本地时间
  if (useLocalDate) {
    try {
      // 要求本地时间和服务器时间误差不能超过1个小时，如果超过1个小时，还是使用服务器时间
      if (Math.abs(now.getTime() - new Date().getTime()) < 3600000) {
        now = new Date()
      }
    } catch (error) {
      console.log(error)
    }
  }

  if (beginTime && endTime) {
    // new Data 的时候 需要将字符时间的 “-” 转成 “/”，否则在 ios 无法正确转换
    let serverTimeNum = now.getTime()
    if (serverTimeNum > helper.UTC8TimeToTimeStamp(beginTime) && serverTimeNum < helper.UTC8TimeToTimeStamp(endTime)) {
      flag = true
    }
  }
  return flag
}

/**
 * 判断时间是否有效
 * @param {} date
 */
export function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime())
}

/**
 * 买过的商品的AMSID存入local中
 * @param {}
 * openid 用户 openid
 * gameid 用户游戏分区信息
 * offerId 业务offerid
 * productId
 */
export function setBuyedPropAMSID({ openid, gameid, offerId, productId }) {
  if (!Array.isArray(productId)) {
    productId = productId.split(",")
  }
  let localBuyedPropKey = ["buyedProp", offerId, openid, gameid].join("_")
  if (!productId || !productId.length) {
    return
  }
  let buyedProps = localStorage.get(localBuyedPropKey) ? localStorage.get(localBuyedPropKey).split(/,/g) : []
  const unionBuyedProps = union(buyedProps, productId) //数组合并去重
  buyedProps = unionBuyedProps
  localStorage.set(localBuyedPropKey, buyedProps.join(","))
}

/**
 * 判断当前productId是否已购买过
 * @param {}
 * openid 用户 openid
 * gameid 用户游戏分区信息
 * offerId 业务offerid
 * productId
 *
 * return true已购买过
 */
export function checkLocalBuyedProp({ openid, gameid = "", offerId, productId }) {
  if (!Array.isArray(productId)) {
    //如果传进来的不是数组变成数组
    productId = productId.split(",")
  }
  if (offerId && openid && productId) {
    let localBuyedPropKey = ["buyedProp", offerId, openid, gameid].join("_")
    let buyedProps = localStorage.get(localBuyedPropKey) ? localStorage.get(localBuyedPropKey).split(/,/g) : []
    const intersectionProps = intersection(buyedProps, productId)
    if (buyedProps && intersectionProps.length > 0) {
      return intersectionProps
    }
    return false
  } else {
    return false
  }
}

/**
 * 买过的商品的过滤规则存入local中
 * @param {}
 * openid 用户 openid
 * gameid 用户游戏分区信息
 * offerId 业务offerid
 * productId
 */
export function setBuyedPropFilterRule({ openid, gameid, offerId, filterRule }) {
  if (!Array.isArray(filterRule)) {
    filterRule = filterRule.split(",")
  }

  let localFilterRuleKey = ["buyedPropFilterRule", offerId, openid, gameid].join("_")
  if (!filterRule) {
    return
  }

  let localFilterRule = localStorage.get(localFilterRuleKey) ? localStorage.get(localFilterRuleKey).split(/,/g) : []
  const unionFilterRule = union(localFilterRule, filterRule) //数组合并去重
  localFilterRule = unionFilterRule
  localStorage.set(localFilterRuleKey, localFilterRule.join(","))
}

/**
 * 判断当前productId是否命中缓存的过滤规则
 * @param {}
 * openid 用户 openid
 * gameid 用户游戏分区信息
 * offerId 业务offerid
 * productId
 */
export function checkLocalBuyedPropFilterRule({ openid, gameid = "", offerId, productId }) {
  if (!productId) {
    return false
  }

  if (!Array.isArray(productId)) {
    //如果传进来的不是数组变成数组
    productId = productId.split(",")
  }

  if (offerId && openid && productId) {
    try {
      let localFilterRuleKey = ["buyedPropFilterRule", offerId, openid, gameid].join("_")
      let localFilterRule = localStorage.get(localFilterRuleKey) ? localStorage.get(localFilterRuleKey).split(/,/g) : []

      if (!localFilterRule || !localFilterRule.length) {
        return false
      }

      let rules = {}
      productId.forEach(id => {
        localFilterRule.forEach(rule => {
          if (id === rule?.split(":")[0] && rule?.split(":")[1]) {
            rules[id] = rule?.split(":")[1]
          }
        })
      })
      return rules
    } catch (error) {
      return false
    }
  } else {
    return false
  }
}

/**
 * 判断是否可购买
 * @param {} prop
 */
export function checkPropCanBuy(prop) {
  if (prop?.goodsExtend?.SellOK === "2") {
    return false
  } else if (
    prop?.goodsExtend?.SellBeginTime &&
    prop?.goodsExtend?.SellEndTime &&
    !checkTimeValid(prop?.goodsExtend?.SellBeginTime, prop?.goodsExtend?.SellEndTime)
  ) {
    return false
  }
  return true
}

/**
 * 根据ItemId获取道具配置
 * @param {*} idsArr 道具ID列表
 * @param {*} vmallConfigByItemID 完整的道具配置
 */
export function getPropsByIds({ idsArr, vmallConfigByItemID }) {
  //idsArr先去重
  if (idsArr && idsArr.length) {
    let uniqueIds = helper.uniqueArr(idsArr)
    let propsArr = []
    uniqueIds.forEach(id => {
      // 推荐物品首先需要去重，其次需要剔除不可购买
      if (vmallConfigByItemID && vmallConfigByItemID[id] && checkPropCanBuy(vmallConfigByItemID[id])) {
        let propsData = Object.assign({}, vmallConfigByItemID[id])
        propsArr.push(propsData)
      }
    })
    return propsArr
  } else {
    return []
  }
}

export function getPropsByGoodsIds({ idsArr, busId, vmallConfigByItemID, vmallConfigByAMSID }) {
  //idsArr先去重
  if (idsArr && idsArr.length) {
    try {
      let uniqueIds = helper.uniqueArr(idsArr)
      let propsArr = []
      uniqueIds.forEach(id => {
        let goodsData = getPropByGoodsId({ id, busId, vmallConfigByItemID, vmallConfigByAMSID })
        // 推荐物品首先需要去重，其次需要剔除不可购买
        if (goodsData && checkPropCanBuy(goodsData)) {
          let propsData = Object.assign({}, goodsData)
          propsArr.push(propsData)
        }
      })
      return propsArr
    } catch {
      return []
    }
  } else {
    return []
  }
}

// 王者使用vmallConfigByAMSID， 其他游戏使用vmallConfigByItemID
export function getPropByGoodsId({ id, busId, vmallConfigByItemID, vmallConfigByAMSID }) {
  if (busId * 1 === 2) {
    return vmallConfigByItemID && vmallConfigByItemID[id]
  } else {
    return vmallConfigByAMSID && vmallConfigByAMSID[id]
  }
}

/**
 * 处理道具数据生成广告数据结构
 * @param {*} props
 * @param {*} groupId
 * @param {*} busId
 * 皮肤：
  subTitle:英雄名
  mainTitle:皮肤名
  description:推荐理由（没有推荐理由的时候放道具描述）

  英雄：
  subTitle:空
  mainTitle:英雄名
  description:推荐理由（没有推荐理由的时候放道具描述）
 */
export function handlePropsDataToAds({ props, groupId, busId, replaceImg = "" }) {
  if (props && props.itemExtend) {
    // 英雄 或一般道具
    let mainTitle = props.name
    let subTitle = ""
    // 皮肤
    if (props.itemExtend.ItemType === "13") {
      mainTitle = props.itemExtend.SkinName || props.name
      subTitle = props.itemExtend.HeroName
    }

    return {
      mainTitle: mainTitle,
      subTitle: subTitle,
      description: (props.goodsExtend && props.goodsExtend.RecommReason) || props.goodsRemark || "",
      url: replaceImg ? replaceImg : props.allIcon && props.allIcon[2],
      newUpTag: props.newUpTag || "",
      hotTag: props.hotTag || "",
      link: {
        groupId: groupId,
        busId: busId,
        goodsId: props.itemExtend && props.itemExtend.AMSID
      }
    }
  } else {
    return {}
  }
}

/**
 * 获取王者英雄详细内容
 */
export function getHeroDetail(params) {
  return new Promise((resolve, reject) => {
    var urlParams = {
      action: "getHeroDetail",
      ...params
    }
    delete urlParams.url
    request
      .ajax({
        url: params.url,
        data: urlParams,
        type: "get"
      })
      .then(
        res => {
          if (res && typeof res == "object" && res !== null) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 处理英雄制胜宝典数据
 */
export function handleZSBDDataContent(data, vmallConfigByItemID, propId) {
  // 英雄关系
  let heroRelation = []
  let relationArr = ["partner", "inhibit", "resist"]
  let relationDesArr = ["part_tip", "in_tip", "re_tip"]
  let originHeroRelationTab = ["最佳搭档", "克制", "被克制"]
  let heroRelationTab = []
  relationArr.forEach((rel, i) => {
    let relationProps = []
    for (let j = 1; j <= 2; j++) {
      if (data[rel + j]) {
        let resProp = vmallConfigByItemID[data[rel + j]]
        if (resProp) {
          relationProps.push({
            id: data[rel + j],
            propName: resProp.name,
            propIcon: resProp.allIcon[0],
            icon: resProp.allIcon[0], // 道具图标
            name: resProp.name, // 道具名称
            des: data[`${relationDesArr[i]}${j}`] || data[`part_yip${j}`]
          })
        }
      }
    }
    heroRelation.push(relationProps)
  })
  // 如果英雄关系里某个tab里没有英雄，则不显示该tab
  heroRelation = heroRelation.filter((item, i) => {
    if (item && item.length > 0) {
      heroRelationTab.push(originHeroRelationTab[i])
      return true
    } else {
      return false
    }
  })

  // 技能效果
  let propAttr = propId ? vmallConfigByItemID[propId] : vmallConfigByItemID[data.ename]
  let skillImgMap = {}
  if (propAttr && propAttr.goodsExtend && propAttr.goodsExtend.skillGifs) {
    propAttr.goodsExtend.skillGifs.split(";").map(function (skill) {
      if (skill && skill.split(",")[0]) {
        skillImgMap[skill.split(",")[0]] = skill.split(",")[1]
      }
    })
  }

  let skillData = []
  let skillDataTab = []
  for (let i = 1; i <= 10; i++) {
    if (data["skill" + i]) {
      let miniDes = ""
      if (data[`skill${i}_cold`]) {
        miniDes += `<span>冷却值：${data[`skill${i}_cold`]}&nbsp;&nbsp;&nbsp;&nbsp;</span>`
      }
      if (data[`skill${i}_use`]) {
        miniDes += `<span>消耗：${data[`skill${i}_use`]}</span>`
      }

      skillData.push({
        icon: `//game.gtimg.cn/images/yxzj/img201606/heroimg/${data["ename"]}/${data["ename"]}${i - 1}0.png`,
        skillId: data[`skill${i}`],
        skillName: data[`skill${i}_name`],
        skillCold: data[`skill${i}_cold`],
        skillUse: data[`skill${i}_use`],
        skillDes: data[`skill${i}_des`].split("</br>"),
        name: data[`skill${i}_name`], // 技能名称
        des: data[`skill${i}_des`].split("</br>"), // 技能描述
        miniDes: miniDes,
        img: skillImgMap[data[`skill${i}`]]
      })
      skillDataTab.push(`//game.gtimg.cn/images/yxzj/img201606/heroimg/${data["ename"]}/${data["ename"]}${i - 1}0.png`)
    }
  }
  return {
    heroRelation: heroRelation,
    heroRelationTab: heroRelationTab,
    skillData: skillData,
    skillDataTab: skillDataTab
  }
}

/**
 * 查询当前的券的状态
 * exchangeResult 0-暂不可兑换，1-已领取，2-领取失败，3-已失效
 * @param coupon
 */
export function getCouponStatus(coupon, svrTime) {
  let timeFlag = checkTimeStatus(coupon.exchange_begin_time, coupon.exchange_end_time)
  if (coupon.status === "9") {
    return {
      exchangeResult: "1",
      remark: "已领取",
      warning: "",
      canExchange: false
    }
  } else if (timeFlag === 2) {
    return {
      exchangeResult: "0",
      remark: "兑换未开始",
      warning: "",
      canExchange: false
    }
  } else if (timeFlag === 3) {
    return {
      exchangeResult: "3",
      remark: "已失效",
      warning: "",
      canExchange: false
    }
  } else if (coupon.status === "1" && coupon.reserve2 > svrTime) {
    return {
      exchangeResult: "0",
      remark: "",
      warning: "",
      canExchange: true
    }
  } else if (coupon.reserve2 <= svrTime) {
    return {
      exchangeResult: "3",
      remark: "已失效",
      warning: "",
      canExchange: false
    }
  }
}

/**
 * 根据商店业务配置，取业务层级不同渠道入口的支付渠道屏蔽情况
 * @param {*}
 */
export function handleGameBizPayDC({ pfSource, payChannel }) {
  let dc = ""

  let dcParam = ua.getUserAgent().iOS ? "iOSDC" : "androidDC"

  let targetPayChannel = payChannel.filter(channel => {
    return channel.pfSource == pfSource
  })

  let defaultPayChannel = payChannel.filter(channel => {
    return channel.pfSource == "default"
  })

  if (targetPayChannel && targetPayChannel.length) {
    dc = (targetPayChannel[0] && targetPayChannel[0][dcParam]) || ""
  } else if (defaultPayChannel && defaultPayChannel.length) {
    dc = (defaultPayChannel[0] && defaultPayChannel[0][dcParam]) || ""
  }

  return dc
}

/**
 * 根据商店业务配置合入source取值
 * @param config [{},{}]
 */
export function handleConfigBySource({ config, pfSource, matchKey = "pfSource" }) {
  let matchConfig = ""
  let targetContent = config?.filter(content => {
    return content[matchKey] == pfSource
  })

  let defaultContent = config?.filter(content => {
    return content[matchKey] == "default"
  })

  if (targetContent && targetContent.length) {
    matchConfig = targetContent[0]
  } else if (defaultContent && defaultContent.length) {
    matchConfig = defaultContent[0]
  }

  return matchConfig
}

/**
 * 按规则选取一条主播购买活动广告
 * @param {}
 * buyGuideList 所有活动广告列表
 * sellerId 主播id
 * itemId 道具id
 */
export function selectAnchorBuyGuide({ buyGuideList, itemId }) {
  if (buyGuideList && buyGuideList.length) {
    // 1. 过滤已失效（过期）的活动
    buyGuideList = buyGuideList
      .filter(buyGuide => {
        return checkTimeValid(buyGuide.onlineTime, buyGuide.offlineTime, true)
      })
      .filter(buyGuide => {
        // 2. 过滤非本道具或非本主播的，isAllAnchor无论是0或1，会出现在buyGuideList里就是该主播可展示的
        // 外部（主播）广告的排序： 指定主播+商品 > 指定主播 > 指定商品 > 全量主播+商品
        return buyGuide.isAllProduct || (!buyGuide.isAllProduct && checkProductInList(itemId, buyGuide.productList))
      })
      .map(buyGuide => {
        if (buyGuide.isAllProduct == 0 && buyGuide.isAllAnchor == 0) {
          buyGuide.sort = 0
        }
        if (buyGuide.isAllProduct == 1 && buyGuide.isAllAnchor == 0) {
          buyGuide.sort = 1
        }
        if (buyGuide.isAllProduct == 0 && buyGuide.isAllAnchor == 1) {
          buyGuide.sort = 2
        }
        if (buyGuide.isAllProduct == 1 && buyGuide.isAllAnchor == 1) {
          buyGuide.sort = 3
        }
        return buyGuide
      })

    buyGuideList.sort((a, b) => {
      // 3. 排序
      return a.sort - b.sort
    })

    let buyGuide = {
      guideText: buyGuideList && buyGuideList[0] && buyGuideList[0].guideText ? decodeURIComponent(buyGuideList[0].guideText) : "",
      remark: buyGuideList && buyGuideList[0] && buyGuideList[0].remark ? decodeURIComponent(buyGuideList[0].remark) : "",
      url: buyGuideList && buyGuideList[0] && buyGuideList[0].url ? decodeURIComponent(buyGuideList[0].url) : ""
    }

    return buyGuide
  } else {
    return {}
  }
}

export function checkProductInList(productId, productList) {
  return (
    productId &&
    productList &&
    productList
      .map(list => {
        return list.itemId
      })
      .indexOf(productId) > -1
  )
}

/**
 * 按菜单分类
 * @param {*}
 * vmallGoodsList 物品券列表
 * menuId 指定菜单id
 */
export function getGoodsByMenuId({ vmallGoodsList, menuId }) {
  return vmallGoodsList.filter(goods => {
    if (goods && goods.menuInfo && goods.menuInfo.length) {
      let menuIdList = goods.menuInfo.map(goodsMenu => {
        return goodsMenu.menuId
      })
      return menuIdList.indexOf(menuId) > -1
    }
    return false
  })
}

// 获取物品活动id
export function getGroupid(good) {
  return checkActivityValid(good) ? good.goodsExtend.ActivityNum : ""
}

// 获取物品活动最大购买数量
export function getActivityMaxQuantity(good) {
  return checkActivityValid(good) ? +good.goodsExtend.MaxQuantity : null
}

// 判断是否走外部带货场景，即不展示商店详情页的物品详情（比如推荐，点赞，相关道具等）
// 结果页 外部带货场景屏蔽推荐，商店广告位，需要显示主播信息和主播广告
// 强制走外部场景 || 带货场景 || 组件调用场景
export function isOuterScene() {
  return (isSpecifyOuterScene() || isAnchorOuterScene() || isDialogMode()) && !isSpecifyInnerScene()
}

export function isSpecifyOuterScene() {
  return urlUtil.getParam("type") == "outer"
}

export function isSpecifyInnerScene() {
  return urlUtil.getParam("type") == "inner"
}

export function isDialogMode() {
  return urlUtil.getParam("mode") == "dialog"
}

export function isAnchorOuterScene() {
  return urlUtil.getParam("tx_chan_type") && urlUtil.getParam("tx_seller_id")
}

export function supportDemandDirectSence() {
  // QQ || 微信且非小程序 || 非jsapi调用场景 才能直接跳转代付页
  let userAgent = ua.getUserAgent()
  return (userAgent.QQ || (userAgent.weixin && !userAgent.weixinminiprogram)) && urlUtil.getParam("mode") != "dialog"
}

// 按上线时间排序
export function sortByOnlineTime(a, b) {
  if (a.OnlineTime && b.OnlineTime) {
    // 当上新时间一样时，判断创建时间
    if (b.OnlineTime == a.OnlineTime) {
      // 当创建时间一样时，判断sort
      return a.sort - b.sort
    } else {
      return new Date(b.OnlineTime).getTime() - new Date(a.OnlineTime).getTime()
    }
  } else {
    //如果没有OnlineTime字段，则a排在前面
    return -1
  }
}

// 按上新日期排序
export function sortByUpTime(a, b) {
  if (a.goodsExtend && a.goodsExtend.UpDate && b.goodsExtend && b.goodsExtend.UpDate) {
    if (a.goodsExtend.UpDate == b.goodsExtend.UpDate) {
      // 当上新时间一样时，判断创建时间
      if (b.OnlineTime == a.OnlineTime) {
        // 当创建时间一样时，判断sort
        return a.sort - b.sort
      } else {
        return new Date(b.OnlineTime).getTime() - new Date(a.OnlineTime).getTime()
      }
    } else {
      return new Date(b.goodsExtend.UpDate.replace(/-/g, "/")).getTime() - new Date(a.goodsExtend.UpDate.replace(/-/g, "/")).getTime()
    }
  } else {
    if (a.goodsExtend && a.goodsExtend.UpDate) {
      //如果a有UpDate字段排在前面
      return -1
    } else if (b.goodsExtend && b.goodsExtend.UpDate) {
      //b有UpDate字段排在前面
      return 1
    } else if (a.OnlineTime && b.OnlineTime) {
      // 当上新时间一样时，判断创建时间
      if (b.OnlineTime == a.OnlineTime) {
        // 当创建时间一样时，判断sort
        return a.sort - b.sort
      } else {
        return new Date(b.OnlineTime).getTime() - new Date(a.OnlineTime).getTime()
      }
    } else {
      //如果没有OnlineTime字段，则a排在前面
      return -1
    }
  }
}

// 获取前100个按上架时间排序的道具
// 王者限定英雄和皮肤，按上架时间排序前100个道具
// 其他游戏按上架时间排序前100个道具
export function getDefaultOrderProps({ vmallGoodsList = [], busId = "" }) {
  if (vmallGoodsList && vmallGoodsList.length) {
    return vmallGoodsList
      .filter(goods => {
        return (
          goods &&
          checkPropCanBuy(goods) &&
          goods.goodsExtend &&
          goods.goodsExtend.ActivityType !== "preOrder" &&
          ((busId == "2" &&
            goods.itemExtend &&
            goods.itemExtend.ItemType &&
            (goods.itemExtend.ItemType == "10" || goods.itemExtend.ItemType == "13")) ||
            busId != "2")
        )
      })
      .sort(sortByOnlineTime)
      .slice(0, 100)
  } else {
    return []
  }
}

/**
 * 判断当前道具是否是英雄
 * @param prop
 * @returns {boolean}
 */
export function checkIfIsHeroItem(prop) {
  return prop.itemExtend && prop.itemExtend.ItemType === "10"
}

/**
 * 判断当前道具是不是皮肤
 * @param prop
 * @returns {boolean}
 */
export function checkIfIsSkinItem(prop) {
  return prop.itemExtend && prop.itemExtend.ItemType === "13"
}

/**
 * 判断当前道具是不是普通皮肤
 * @param prop
 * @returns {boolean}
 */
export function checkIfIsNormalSkinItem(prop) {
  return (
    prop.itemExtend &&
    prop.itemExtend.ItemType === "13" &&
    (!prop.itemExtend.RelyItemId || prop.itemExtend.RelyItemId === " ") &&
    (!prop.goodsExtend || prop.goodsExtend.ActivityType !== "preOrder")
  )
}

/**
 * 判断当前道具是不是星元皮肤
 * @param prop
 * @returns {boolean}
 */
export function checkIfIsXingyuanSkinItem(prop) {
  return (
    prop.itemExtend &&
    prop.itemExtend.ItemType === "13" &&
    prop.itemExtend.RelyItemId &&
    prop.itemExtend.RelyItemId !== " " &&
    (!prop.goodsExtend || prop.goodsExtend.ActivityType !== "preOrder")
  )
}

/**
 * 检测某个某个物品是不是从属于某个英雄的星元皮肤(这个方法名没有起的很好)
 * @param good
 * @param hero
 * @returns {*|StackTraceId|boolean}
 */
export function checkIfIsSkin(good, hero) {
  let itemId = hero.itemId
  let amsId = hero.itemExtend.AMSID

  return (
    (good &&
      good.parentId &&
      good.parentId === itemId &&
      good.itemExtend &&
      good.itemExtend.ItemType === "13" &&
      (!good.itemExtend.RelyItemId || good.itemExtend.RelyItemId === " ") &&
      (!good.goodsExtend || good.goodsExtend.ActivityType !== "preOrder")) ||
    (good && good.itemExtend && good.itemExtend.ParentId && good.itemExtend.ParentId === amsId)
  )
}

/**
 * 检测某个物品是不是从属于某个英雄的星元皮肤（这个方法名没有起的很好）
 * @param good
 * @param hero
 * @returns {*|StackTraceId|boolean}
 */
export function checkIfIsXingyuan(good, hero) {
  return (
    good &&
    good.parentId &&
    good.parentId === hero.itemId &&
    good.itemExtend &&
    good.itemExtend.ItemType === "13" &&
    good.itemExtend.RelyItemId &&
    good.itemExtend.RelyItemId !== " " &&
    (!good.goodsExtend || good.goodsExtend.ActivityType !== "preOrder")
  )
}

// 星元皮肤 102
// 英雄 10
// 皮肤 13
// 战令 4
// 其他 -1
export function getProductClassifyId(goods) {
  if (checkIfIsXingyuanSkinItem(goods)) {
    return "102"
  } else if (goods?.itemExtend?.ItemType) {
    return goods?.itemExtend?.ItemType
  } else {
    return "-1"
  }
}

/**
 * 纯前端背包过滤结果
 * 若有背包过滤，则返回错误的结果
 * 后续建议所有的查前端背包过滤都从这里取，保证逻辑的一致性
 * @param options
 * @returns {Promise<unknown>|boolean|{errCode: number}}
 * has: 用户是否有此物品的缓存
 * errcode: 错误码（可根据不同的情况返回不同的值）
 * filterCacheBuyed： 缓存原始数据
 */
export function checkFrontFilteredBag(options) {
  // 过滤缓存
  const filterCacheBuyed = checkLocalBuyedProp({
    openid: options.openid,
    gameid: options.gameid,
    productId: options.productId,
    offerId: options.offerId
  })

  /**
   * 已购买拦截逻辑说明
   * 1.单个物品购买，前端缓存直接拦截
   * 2.多个物品购买，且所有物品都已购买过，直接拦截
   */
  if (!Array.isArray(options.productId) && filterCacheBuyed && filterCacheBuyed.length > 0) {
    return {
      has: true,
      errCode: 2310,
      filterCacheBuyed
    }
  }

  if (Array.isArray(options.productId) && filterCacheBuyed.length == options.productId.length) {
    return {
      has: true,
      errCode: 2310,
      boughtProduct: options.productId,
      filterCacheBuyed
    }
  }

  /**
   * 新增前端缓存过滤逻辑 || 不影响评分部分对背包过滤的判断，故增加checkFilterRule参数控制
   */
  if (options?.checkFilterRule) {
    const filterRule = checkLocalBuyedPropFilterRule({
      openid: options.openid,
      gameid: options.gameid,
      productId: options.productId,
      offerId: options.offerId
    })

    // 购买多个物品只处理已经购买过的物品，所以暂时这里只针对单个道具购买进行校验
    if (!Array.isArray(options.productId) && filterRule && filterRule[options.productId]) {
      return {
        has: filterRule[options.productId] == 2310,
        errCode: parseInt(filterRule[options.productId]),
        filterCacheBuyed
      }
    }
  }

  return {
    has: false,
    errCode: "",
    filterCacheBuyed
  }
}

// 判断券有效性（drm券 + 王者券）
export function checkCouponExist(selectedCoupon) {
  return (
    (selectedCoupon?.type == "game_coupon" && selectedCoupon?.couponId) ||
    (selectedCoupon?.type !== "game_coupon" && selectedCoupon && selectedCoupon?.codeId && selectedCoupon?.batchId)
  )
}

// 判断券被冻结（drm券 + 王者券）
export function checkCouponFrozen(selectedCoupon) {
  return (
    (selectedCoupon?.type == "game_coupon" && selectedCoupon.status == couponStatus.GAMECOUPON_FROZEN) ||
    (selectedCoupon?.type !== "game_coupon" && selectedCoupon.status & couponStatus.FROZEN)
  )
}

export function checkCouponIsGameCoupon(coupon) {
  return coupon?.type == "game_coupon"
}

export function handleCouponData(coupon) {
  return {
    ...coupon,
    couponId: coupon?.coupon_id,
    saving: coupon.amt,
    status: coupon.state,
    cardId: coupon?.card_id,
    batchId: coupon?.batch_id,
    codeId: coupon?.code_id,
    name: coupon?.name || ""
  }
}

/**
 * 获得英雄的皮肤信息
 * @param showPropsList
 * @param hero
 * @returns {*[]}
 */
export function getSkinOfHero(showPropsList, hero) {
  const xingyuan = []
  const skin = []

  showPropsList.forEach(good => {
    if (checkIfIsSkin(good, hero)) {
      skin.push(good)
    }

    if (checkIfIsXingyuan(good, hero)) {
      xingyuan.push(good)
    }
  })

  return [...skin, ...xingyuan]
}

/**
 * 根据首字母排序
 * @param data
 * @returns {[]}
 */
export function sortByCharacter(data) {
  let result = []
  let begin = "a".charCodeAt(0)
  let idx = null
  let end = "z".charCodeAt(0)
  let list = []
  for (let i = begin; i <= end; i++) {
    idx = String.fromCharCode(i)
    list = data[idx]
    if (list) {
      result.push({
        char: idx.toUpperCase(),
        list: list.sort((item1, item2) => {
          return item1.pinyin && item2.pinyin ? item1.pinyin.toLowerCase() > item2.pinyin.toLowerCase() : false
        })
      })
    }
  }
  return result
}

/**
 * 道具根据sort字段进行排序
 * @param a
 * @param b
 * @returns {number}
 */
export function goodsSort(a, b) {
  if (a.sort >= 0 && b.sort >= 0) {
    return a.sort - b.sort
  } else {
    if (a.sort >= 0) {
      //如果a有sort字段排在前面
      return -1
    } else if (b.sort >= 0) {
      //b有sort字段排在前面
      return 1
    } else {
      return 0
    }
  }
}

/**
 * 根据物品在指定菜单中的sort字段进行排序
 * @param {*} menuId 指定的menuId
 */
export function goodsSortByMenuSort(menuId) {
  return (a, b) => {
    if (menuId) {
      try {
        let sorta = a.menuInfo.find(menu => {
          return menu.menuId === menuId
        }).sort
        let sortb = b.menuInfo.find(menu => {
          return menu.menuId === menuId
        }).sort
        return sorta - sortb
      } catch (error) {
        return goodsSort(a, b)
      }
    } else {
      return goodsSort(a, b)
    }
  }
}

export function getShopName() {
  return document.title
}

/**
 * 获取道具奖励任务配置
 * @param {*} prop 道具信息
 * @returns
 */
export function getGiftTask(prop) {
  if (prop && prop.goodsExtend && prop.goodsExtend.GiftTask) {
    try {
      return JSON.parse(prop.goodsExtend.GiftTask)
    } catch {
      return null
    }
  } else {
    return null
  }
}

/**
 *  * 获取道具秒杀活动配置
 * @param {*} prop 道具信息
 * @returns
 */
export function getSeckillActivity(prop) {
  if (prop && prop.goodsExtend && prop.goodsExtend.SeckillActivity) {
    try {
      return JSON.parse(prop.goodsExtend.SeckillActivity)
    } catch {
      return null
    }
  } else {
    return null
  }
}

/**
 * 获取特定折扣卡信息，比如60卡
 * @param prop 道具信息
 */
export function getSpecificDiscountCard(prop, vmallConfigByAMSID) {
  const info = urlUtil.getParams(prop?.goodsExtend?.specificDiscountCard)
  if (info.amsid) {
    const cardInfo = vmallConfigByAMSID[info.amsid]
    if (!isOffline(cardInfo)) {
      return cardInfo
    }
    return null
  } else {
    return null
  }
}

export function getSpecific60CardCoupon(prop) {
  return urlUtil.getParams(prop?.goodsExtend?.specificDiscountCard)
}
